import type { OfferLeadDiversionReason, OfferPlanAvailability } from '../types';

type LeadDiversion =
  { divert: false } | { divert: true; reason: OfferLeadDiversionReason };

/**
 * FIN-8016: depois do lead cadastrado, oferta encerrada ou ainda não aberta
 * (FIN-8011, decisão 14) vai para a página de obrigado em vez do
 * pagamento. Renovação segue o fluxo dela.
 * Sem o bloco `plan` (BFF antigo), não desvia: o /v3 é a barreira final.
 */
export function resolveOfferLeadDiversion({
  isOfferFlow,
  offerAvailability,
  leadRoute,
}: {
  isOfferFlow: boolean;
  offerAvailability: OfferPlanAvailability | null | undefined;
  leadRoute?: string | null;
}): LeadDiversion {
  if (!isOfferFlow || leadRoute?.includes('renew')) {
    return { divert: false };
  }

  switch (offerAvailability?.availability) {
    // FIN-8119 (D05/D08): esgotado; o BFF já dá prioridade a ele sobre as datas.
    case 'SOLD_OUT':
      return { divert: true, reason: 'sold_out' };
    case 'EXPIRED':
      return { divert: true, reason: 'expired' };
    // FIN-8011 (decisão 14): vendas ainda não abriram; mesmo desvio do EXPIRED.
    case 'NOT_STARTED':
      return { divert: true, reason: 'not_started' };
    default:
      return { divert: false };
  }
}
